import Entity from '@/common-utils/components/renders/entity/Entity';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import PropTypes from 'prop-types';


/**
 *
 * @param root0
 * @param root0.onClose
 * @param root0.title
 * @param root0.body
 */
function ModalFunctionNotActivated({ isOpen, setIsOpen, title, body, namespace }) {
    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className={cn('max-w-lg')}>
                <HeaderTitle title={title} namespace={namespace} />
                <ModalBody className='text-center mb-2'>
                    <Entity entity={body} namespace={namespace} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

ModalFunctionNotActivated.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    namespace: PropTypes.string
};

export default ModalFunctionNotActivated;